import { RootState } from '@iwProvider/configureStore';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import styles from '../LinkDebitCard.module.css';
import StripeLinkDebitCardForm from './StripeLinkDebitCardForm';
import IwStripeProvider from '../../../iwStripeProvider/IwStripeProvider';
import { getStripePublicKey } from '../../../iwStripeProvider/StripeHelper';
import { PaymentMethodAuthenticationModal } from '../../modals/paymentMethodAuthenticationModal/PaymentMethodAuthenticationModal';

const mapStateToProps = ({
    addPaymentMethodModal
}: {
    addPaymentMethodModal: RootState['addPaymentMethodModal'];
}) => addPaymentMethodModal;

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const LinkDebitCard = ({
    requiresAuthentication,
    authenticationIframeURL,
    authenticationFailed,
    showTitle = true, // Option used to remove title when used in an accordion
    showSubText = true,
    showDefaultPaymentMethodCheckbox = false
}: {
    showTitle?: boolean;
    showSubText?: boolean;
    showDefaultPaymentMethodCheckbox?: boolean;
} & PropsFromRedux) => {
    if (requiresAuthentication) {
        return (
            <PaymentMethodAuthenticationModal
                authenticationIframeURL={authenticationIframeURL!}
            />
        );
    }

    return (
        // @ts-expect-error Not in TS yet
        <IwStripeProvider stripeKey={getStripePublicKey()}>
            <>
                {(showTitle || authenticationFailed) && (
                    <div className={styles.title}>
                        {showTitle && (
                            <FormattedMessage
                                id="_.link_debit_card.title"
                                defaultMessage="Link your debit card"
                            />
                        )}
                        {authenticationFailed && (
                            <div className={styles.linkDebitCardError}>
                                <FormattedMessage
                                    id="_.link_debit_card.error"
                                    defaultMessage="Failed to register the card. Please try again."
                                />
                            </div>
                        )}
                    </div>
                )}
                <div className={styles.LinkDebitCard}>
                    <StripeLinkDebitCardForm
                        showSubText={showSubText}
                        showDefaultPaymentMethodCheckbox={
                            showDefaultPaymentMethodCheckbox
                        }
                    />
                </div>
            </>
        </IwStripeProvider>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(LinkDebitCard);
